<template>
  <div :class="['intro', effect]" v-bind:id="id ? id : null">
    <div
      :class="[
        'intro__description',
        boostrap ? 'intro__description--none' : ''
      ]"
    >
      <slot name="action-left" />
      <span class="intro__description--title">{{ title }}</span>
      <div
        :class="[
          'intro__description--action',
          hideActionDesktop ? 'intro__description--action-desktop-none' : '',
          hideActionMobile ? 'intro__description--action-mobile-none' : ''
        ]"
      >
        <slot name="action" />
      </div>
    </div>
    <span
      :class="[
        'intro--subtitle',
        !subtitleMobile ? 'intro--subtitle-none' : ''
      ]"
      v-if="subtitle"
      v-html="subtitle"
    ></span>
    <div class="intro__bootstrap" v-if="boostrap">
      <span class="intro__bootstrap--path" @click="goTo(page)">{{ path }}</span>
      <span class="intro__bootstrap--slash">/</span>
      <span class="intro__bootstrap--title">{{ title }}</span>
    </div>
  </div>
</template>

<script setup>
  defineProps({
    title: String,
    subtitle: String,
    path: String,
    page: { type: String, default: 'Home' },
    subtitleMobile: { type: Boolean, default: true },
    subtitleColor: { type: String, default: '#313235' },
    subtitleFontSize: { type: String, default: '28px' },
    subtitlePadding: { type: String, default: '0px' },
    subtitleLineHeight: { type: String, default: '32px' },
    backgroundColor: { type: String, default: '#FFFFFF' },
    backgroundMobileColor: { type: String, default: '#FFFFFF' },
    padding: { type: String, default: '50px' },
    paddingDesktop: { type: String, default: '30px 50px' },
    align: { type: String, default: 'initial' },
    flow: { type: String, default: 'column' },
    gap: { type: String, default: '0px' },
    descriptionAlign: { type: String, default: 'center' },
    descriptionMobileAlign: { type: String, default: 'initial' },
    titleFontSize: { type: String, default: '40px' },
    titleMobileFontSize: { type: String, default: '20px' },
    id: { type: String },
    effect: { type: String },
    transform: { type: String, default: 'none' },
    transformDesktop: { type: String, default: 'none' },
    boostrap: { type: Boolean, default: false },
    hideActionMobile: { type: Boolean, default: false },
    hideActionDesktop: { type: Boolean, default: false }
  })

  import router from '@/router'
  const goTo = (page) => {
    router.push({ name: page })
  }
</script>

<style lang="scss">
  @import '@/scss/mixings';

  .intro {
    @include d-flex(column, flex-start, v-bind(align), v-bind(gap));
    padding: v-bind(padding);
    background-color: v-bind(backgroundMobileColor);
    width: 100%;
    @media screen and (min-width: $sm-breakpoint) {
      padding: v-bind(paddingDesktop);
      background-color: v-bind(backgroundColor);
    }
    &__description {
      @include d-flex(v-bind(flow), space-between, v-bind(descriptionAlign));

      &--title {
        color: #313235;
        font-family: 'OnAir-text-black';
        font-style: normal;
        font-weight: 700;
        line-height: 30px;
        font-size: v-bind(titleFontSize);
        text-transform: v-bind(transformDesktop);
        @media screen and (max-width: $sm-breakpoint) {
          font-size: v-bind(titleMobileFontSize);
          text-transform: v-bind(transform);
        }
      }
      &--action {
        @media screen and (min-width: $sm-breakpoint) {
          display: block;
        }
        &-desktop-none {
          @media screen and (min-width: $sm-breakpoint) {
            display: none;
          }
        }
        &-mobile-none {
          @media screen and (max-width: $sm-breakpoint) {
            display: none;
          }
        }
      }
      @media screen and (min-width: $sm-breakpoint) {
        flex-direction: row;
      }
      @media screen and (max-width: $sm-breakpoint) {
        @include d-flex(
          v-bind(flow),
          space-between,
          v-bind(descriptionMobileAlign)
        );
      }
    }
    &--subtitle {
      color: v-bind(subtitleColor);
      font-family: 'OnAir-text-bold';
      font-size: v-bind(subtitleFontSize);
      font-style: normal;
      font-weight: 400;
      line-height: v-bind(subtitleLineHeight);
      padding-top: v-bind(subtitlePadding);
      @media screen and (min-width: $sm-breakpoint) {
        color: #86888c;
        font-size: 18px;
        line-height: 30px;
      }
    }
    &--subtitle-none {
      @media screen and (max-width: $sm-breakpoint) {
        display: none;
      }
    }
    &__bootstrap {
      display: none;
      @media screen and (min-width: $sm-breakpoint) {
        @include d-flex(row, flex-start, center, 5px);
        padding: 10px 0px;
      }
      &--path {
        cursor: pointer;
        color: #313235;
        font-size: 18px;
        font-weight: 400;
        line-height: 28px;
        &:hover {
          color: var(--primary-10-color);
        }
      }
      &--slash {
        color: #999;
      }
      &--title {
        color: #999;
        font-size: 18px;
        font-weight: 400;
        line-height: 28px;
      }
    }
  }
</style>
